import { Customer } from '../types'

export const upsertCustomerWithLimitAtStart = (arr: readonly Customer[], item: Customer, limit: number) => {
  if (!Number.isFinite(limit) || limit <= 0) return []

  const idx = arr.findIndex((x) => x._id === item._id)

  let next: Array<Customer>

  if (idx >= 0) {
    next = arr.slice()
    next[idx] = item
  } else {
    next = [item, ...arr]
  }

  return next.length > limit ? next.slice(0, limit) : next
}
